import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type HomeSectionKey = 'POSTS' | 'EVENTS' | 'BLOGS';

export interface HomeSectionConfig {
  key: HomeSectionKey;
  title: string;
  subtitle?: string;
  isVisible: boolean;
  order: number;
}

/**
 * Landing-page layout managed by the super admin in the back office
 * (Admin → Home Page Content): which sections show, their order and headings.
 * The content inside each section comes from the existing /featured
 * endpoints, which already honour the admin's selections.
 */
@Injectable({ providedIn: 'root' })
export class HomeContentService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl = `${environment.apiUrl}/home-content`;

  getSections(): Observable<any> {
    // Same as the /featured calls: the sections are populated client-side.
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    return this.http.get(`${this.baseUrl}/sections`);
  }
}
